import { useEffect, useState } from 'react';
import { Image } from '../ProductDetail/styled';
import RatingStar from '../RatingandReviews/RatingStar';
import VerifiedTag from '../RatingandReviews/VerifiedTag';
import Wasthishelpful from '../RatingandReviews/Wasthishelpful';
import {
  ReviewCenter,
  UserBody,
  UserContentTitle,
  UserImageWrapper,
  UserInfo,
  UserName,
  UserRating,
} from './styled';

export default function UserDetailImagesByUser(props) {
  const {
    data,
    carouselFeedback,
    setShowCarouseFeedBackBannerOnIndex,
    setSeeMoreOnIndexBasis,
  } = props;
  const [showclass, setShowClass] = useState('lineRestrict');
  const [readText, setReadText] = useState('Read More');

  const reviewContent = data?.content?.body
    .replace(/(<([^>]+)>)/gi, '')
    .replace('&nbsp;', '');

  const setSeeMore = (index, text) => {
    if (text == 'Read More') {
      setReadText('Read Less');
      setShowClass('fullContent');
    } else {
      setReadText('Read More');
      setShowClass('lineRestrict');
    }
    setSeeMoreOnIndexBasis(index);
  };

  useEffect(() => {
    if (data?.seeMore == true) {
      setReadText('Read Less');
      setShowClass('fullContent');
    } else {
      setReadText('Read More');
      setShowClass('lineRestrict');
    }
  }, [data?.seeMore]);

  return (
    <>
      {data && (
        <UserImageWrapper desktop>
          <ReviewCenter>
            <UserInfo>
              <Image
                src={data?.content?.user_details?.thumbImages}
                width={42}
                height={42}
                radius="50%"
                alt={`${
                  data?.content?.anonymous
                    ? 'Anonymous'
                    : data?.content?.user_details?.username
                } user avatar`}
              />
              <UserName>
                <div>
                  <p className="name">
                    {data?.content?.anonymous
                      ? 'Anonymous'
                      : data?.content?.user_details?.username}
                  </p>
                  <UserRating>
                    <RatingStar rating={data?.rating} />
                  </UserRating>
                </div>
                <VerifiedTag />
              </UserName>
            </UserInfo>
            <UserContentTitle>{data?.content?.title}</UserContentTitle>
            <UserBody showMobileOnly>
              <div className={showclass}>
                {data?.content?.body
                  .replace(/(<([^>]+)>)/gi, '')
                  .replace('&nbsp;', '')}
              </div>
              {reviewContent?.length > 120 && (
                <span
                  className="readmoreStyle"
                  onClick={() =>
                    setSeeMore(
                      data?.selectedIndex ? data?.selectedIndex : 0,
                      readText,
                    )
                  }
                >
                  {readText}
                </span>
              )}
            </UserBody>
            <UserBody showDesktopOnly>
              {data?.content?.body
                .replace(/(<([^>]+)>)/gi, '')
                .replace('&nbsp;', '')}
            </UserBody>
            <Wasthishelpful
              reviewId={data?.id}
              isReviewed={data?.isReviewed}
              propertyTag={data?.content?.propertytags}
              helpFulData={data?.helpful_counts}
              popupHelpful={true}
              carouselFeedback={carouselFeedback}
              setShowCarouseFeedBackBannerOnIndex={
                setShowCarouseFeedBackBannerOnIndex
              }
              selectedIndex={data?.selectedIndex ? data?.selectedIndex : 0}
            />
          </ReviewCenter>
        </UserImageWrapper>
      )}
    </>
  );
}
